import React from 'react';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip';
import { ICON_TYPE_TOOLTIP } from '../Icon/constants';
import './Label.css';
import withTheme from '../../hocs/withTheme';
import IconWithTooltip from 'components/common/IconWithTooltip';

type LabelProps = {
    htmlFor?: string;
    label?: string;
    labelInfo?: string;
    helpText?: boolean | string;
    labelInfobox?: boolean;
    required?: boolean;
};

function Label({
    htmlFor = '',
    label = '',
    helpText = '',
    labelInfobox = false,
    required = false,
    labelInfo = '',
}: LabelProps) {
    return (
        <label className={required ? 'Form-control-label required' : 'Form-control-label'} htmlFor={htmlFor}>
            <span>{label}</span>
            {(labelInfobox && helpText) && (
                <Tooltip title={helpText}><span role="button" tabIndex={0}><Icon type={ICON_TYPE_TOOLTIP} /></span></Tooltip>
            )}
            {labelInfo && <IconWithTooltip description={labelInfo} />}
        </label>
    );
}

export default withTheme(Label);
